import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

import { FileInfo } from 'components/Types/GeneralTypes';
import InputFileUpload from '../InputFileUpload';
import BuscadorServidor from 'components/Admin/Horas Extras/Ingreso Manual Solicitudes HE/BuscadorServidor';
import { InformacionAprobadoresHEDTO } from 'components/DirectivoUnidad/Horas Extras/PlanificacionHE/TypesPlanificacionHE';
import SelectItem2 from '../SelectNew';
import { tiposIdentificacion } from 'components/InformacionFamiliar';
import ModalCargando from '../ModalCargando';

type FileInputConfig = {
    id: string; // Identificador único para el input
    label: string; // Label descriptivo para el input
    placeholder: string; // Placeholder para el input
    accept?: string; // Tipos de archivo aceptados (opcional)
};

type ModalFileUploadFlexibleProps = {
    isOpen: boolean;
    toggle: () => void;
    onFilesUpload: (files: FileInfo[], informacionAprobador: any) => Promise<void>; // Callback con los archivos subidos
    title: string;
    description: string;
    inputsConfig: FileInputConfig[]; // Lista de configuraciones para los inputs
    opcionesDirectivo: InformacionAprobadoresHEDTO[]
};

const ModalFileUploadFlexible: React.FC<ModalFileUploadFlexibleProps> = ({
    isOpen,
    toggle,
    onFilesUpload,
    title,
    description,
    inputsConfig,
    opcionesDirectivo
}) => {
    const [files, setFiles] = useState<FileInfo[]>([]);
    const [datospersona, setdatospersona] = useState<number>(0)
    const [loadingAccion, setloadingAccion] = useState<boolean>(false)

    const handleFileUpload = (id: string, archivo: File) => {
        setFiles((prevFiles) => ([
            ...prevFiles,
            {
                file: archivo,
                id,
                nombreFile: id
            }

            // Guarda el archivo bajo su ID único
        ]));

    };

    const modalToggle = () => {
        setFiles([]);
        setdatospersona(0)
        document.body.classList.remove('modal-open')
        toggle()
    }

    const handleSubmit = async () => {
        if (files.length === inputsConfig.length && datospersona > 0) {
            setloadingAccion(true)
            await onFilesUpload(files, datospersona); // Envía todos los archivos al componente padre
            setloadingAccion(false)
            modalToggle(); // Cierra el modal
        } else {
            alert("Por favor, sube todos los archivos requeridos.");
        }
    };

    return (
        <React.Fragment>
            <Modal isOpen={isOpen} toggle={modalToggle}>
                <ModalHeader toggle={modalToggle}>{title}</ModalHeader>
                <ModalBody style={{height:"80vh"}}>
                    <p>{description}</p>
                    {inputsConfig.map((config) => (
                        <div key={config.id} style={{ marginBottom: '1rem' }}>
                            <label>{config.label}</label>
                            <InputFileUpload
                                icon="upload"
                                onChange={(name, archivo) => handleFileUpload(config.id, archivo)}
                                name={config.id}
                                id={config.id}
                                placeholder={config.placeholder}
                                accept={config.accept} // Pasa el tipo de archivo aceptado
                            />
                        </div>
                    ))}

                    <div>
                        <label> Directivo Aprobador </label>
                        <SelectItem2
                            options={opcionesDirectivo.map(opd => ({ value: opd.idpersona, label: opd.apellidos + " " + opd.nombres }))}
                            placeholder=""
                            name="anio"
                            id="anio"
                            icon="fa-caret-down"
                            value={datospersona}
                            onChange={(v, n, t, l) => {
                                setdatospersona(+v)

                            }
                            }
                        />
                    </div>

                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={modalToggle}>
                        Cancelar
                    </Button>
                    <Button color="primary" onClick={handleSubmit}>
                        Aceptar
                    </Button>
                </ModalFooter>
            </Modal>
            <ModalCargando
                show = {loadingAccion}
                size='md'
                onClose={() => setloadingAccion(false)}
                textoCargando='Realizando acción'
            />
        </React.Fragment>

    );
};

export default ModalFileUploadFlexible;